module.exports = __webpack_public_path__ + "static/background-1210dd7d16e85495364feebd7e3a4b2a.gif";